"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogsLocalHistoryService = (function () {
    function LogsLocalHistoryService(sessionService) {
        var _this = this;
        this.UpdateLogHitory = function (userId,filter) {
            if (_this.sessionService.isSupported) {
                if (isObject(filter)) {
                    _this.sessionService.set("lastVisitedLogs_" + userId, JSON.stringify(filter));
                }
            }
        };
        this.DeleteHistory = function(userId) {
            if (_this.sessionService.isSupported)
                _this.sessionService.remove("lastVisitedLogs_" + userId);
        }
        this.GetLogHistory = function (userId) {
            if (_this.sessionService.isSupported) {
                var history = _this.sessionService.get("lastVisitedLogs_" + userId);
                if (history == null || history.length == 0)
                    return null;
                let response = null;
                try {
                    response = JSON.parse(history);
                } catch (e) {}
                return response;
            }
            return null;
        };

        function isObject(val) {
            return (typeof val === 'object');
        }
        this.sessionService = sessionService;
    }
    return LogsLocalHistoryService;
}());
LogsLocalHistoryService.$inject = ['sessionService'];
exports.LogsLocalHistoryService = LogsLocalHistoryService;
//# sourceMappingURL=projectsLocalHistoryService.js.map



// WEBPACK FOOTER //
// ./src/services/history/logsLocalHistoryService.js